import React from "react";
import {Route} from "react-router-dom";
import Reducer from "./reducer";
import Cart from "./Cart";
import PlaceOrder from "./PlaceOrder";
import Confirm from "./Confirm";
import Shipping from "./Shipping";
import PaymentLink from "./PaymentLink";
import Subscribe from "./Subscription/Subscribe";
import CartPopup from "./Blocks/CartPopup";

const POS = React.lazy(() => import("./POS"));

let routes =[
	<Route key="cart_page" 		exact path="/cart" 				element={<Cart />} />,
	<Route key="cart_order" 	exact path="/cart/order" 		element={<PlaceOrder />} />,
	<Route key="cart_payment" 	exact path="/cart/confirm/:id" 	element={<Confirm />} />,
	<Route key="cart_shipping" 	exact path="/cart/shipping/:id" element={<Shipping />} />,
	<Route key="cart_pos" 		exact path="/pos" 				element={<POS />} />,
	<Route key="cart_pay_link" 	exact path="/cart/pay/link/:reference" element={<PaymentLink />} />,
];

if(process.env.REACT_APP_ENABLE_SUBSCRIPTION) {
	routes.push(<Route key="cart_subscribe" exact path="/subscribe" element={<Subscribe />} />);
}

const cartInit = {
	routes,
	reducers: {cart: Reducer},
	blocks: {
		"cart-popup": {
			component: CartPopup,
			setting: {}
		},
	},
	i18n: {
		en: {},
		ar: {
			"Coupon not valid": "الكود غير صحيح"
		}
	},
}

export default cartInit;

